export default "__VITE_ASSET__7b4bbd76__"